import { get, writable } from 'svelte/store';
import { base_url, makeRequestWithSilentLogin } from '../stores/GeneralStore';
export const firmPath = "firms";
/**
 * Function for creating the query part of the url
 * @param listFilter An object which holds all the key values for the query param.
 * @returns
 */
export function createQueryFromFilter(listFilter) {
    let filterString = "?" + `${encodeURIComponent("page")}=${encodeURIComponent(listFilter.page)}&`;
    listFilter.filterOptions.forEach(option => {
        if (option.key != null && (option.value != null)) {
            filterString += `${encodeURIComponent(option.key)}=${encodeURIComponent(option.value)}&`;
        }
    });
    if (listFilter.size) {
        filterString += `${encodeURIComponent("size")}=${encodeURIComponent(listFilter.size)}&`;
    }
    if (listFilter.deletedCounter > 0) {
        filterString += `${encodeURIComponent("deletedCounter")}=${encodeURIComponent(listFilter.deletedCounter)}&`;
    }
    if (listFilter.sortingKey) {
        filterString += `${encodeURIComponent("sorting")}=${encodeURIComponent(listFilter.sortingOrder + "|" + listFilter.sortingKey)}`;
    }
    return filterString;
}
/**
 * Create a query string from the key value pair.
 * @param key
 * @param value
 * @returns
 */
export function createQueryParameterFromString(key, value) {
    return "?" + `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
}
export let selectedClientStore = writable(null);
export const clientPath = "clients";
const queueTaskPath = "tasks";
const initialDataPath = "initial-data";
/**
 * Initial load for a client to setup the application
 * @returns The initial data used for the application
 */
export async function getInitialData() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + initialDataPath;
    return makeRequestWithSilentLogin(url);
}
/**
 * Load a list of QueueTasks for this client
 * @param filter
 * @returns
 */
export async function getQueueTasks(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + queueTaskPath;
    return makeRequestWithSilentLogin(url + query);
}
/**
 * Get a single QueueTask
 * @param queueTaskId
 * @returns
 */
export async function getQueueTask(queueTaskId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + queueTaskPath + "/" + queueTaskId;
    return makeRequestWithSilentLogin(url);
}
const queueTaskLogsPath = "logs";
/**
 * Load a list of QueueTasks for this client
 * @param filter
 * @param queueTaskId
 * @returns
 */
export async function getQueueTaskLogs(queueTaskId, filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + queueTaskPath + "/" + queueTaskId + "/" + queueTaskLogsPath;
    return makeRequestWithSilentLogin(url + query);
}
const folderPath = "folders";
/**
 * Load the list of all none archived folders the user has access to.
 * @param filter The query param used to query the folders.
 * @returns list of filtered folders.
 */
export async function getFolders(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + folderPath;
    return makeRequestWithSilentLogin(url + query);
}
export async function getFolder(folderId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + folderPath + "/" + folderId;
    return makeRequestWithSilentLogin(url);
}
export async function patchFolder(patchFolder, folderId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + folderPath + "/" + folderId;
    return makeRequestWithSilentLogin(url, {
        method: "PATCH",
        body: JSON.stringify(patchFolder)
    });
}
export async function deleteFolder(folderId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + folderPath + "/" + folderId;
    return makeRequestWithSilentLogin(url, {
        method: "DELETE",
    });
}
export async function createFolder(folder) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + folderPath;
    return makeRequestWithSilentLogin(url, {
        method: "POST",
        body: JSON.stringify(folder)
    });
}
const systemPositionTypePath = "system-position-types";
/**
 * Load the list of all available system positon types.
 * @returns
 */
export async function getSystemPositionTypes() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + systemPositionTypePath);
}
export const documentPath = "documents";
const copyPath = "copy";
/**
 * Load the list of documents for a given filter
 * @param filter the document list filter
 * @returns list of folders
 */
export async function getDocuments(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath;
    return makeRequestWithSilentLogin(url + query);
}
//Load a document with all it's dependecies
export async function getDocument(documentId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId);
}
export async function createDocument(folderId, document) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + folderPath + "/" + folderId + "/" + documentPath + "";
    return makeRequestWithSilentLogin(url, {
        method: "POST",
        body: JSON.stringify(document)
    });
}
const smallDocumentRepresentationCopyPath = "small-doc-rep-copy";
export async function copyDocumentSmallDocumentRepresentation(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + smallDocumentRepresentationCopyPath;
    return makeRequestWithSilentLogin(url, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const moneyDocumentRepresentationCopyPath = "money-doc-rep-copy";
export async function copyDocumentMoneyDocumentRepresentation(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + moneyDocumentRepresentationCopyPath;
    return makeRequestWithSilentLogin(url, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const partnerDocumentRepresentationCopyPath = "partner-doc-rep-copy";
export async function copyDocumentpartnerDocumentRepresentation(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + partnerDocumentRepresentationCopyPath;
    return makeRequestWithSilentLogin(url, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Patch an existing document
export async function patchDocument(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing document
export async function deleteDocument(documentId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId;
    return makeRequestWithSilentLogin(url, {
        method: "DELETE",
    });
}
//Delete multiple documents at once.
export async function deleteDocuments(documentIds) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = "?documentIds=" + documentIds.join(";");
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath;
    return makeRequestWithSilentLogin(url + query, {
        method: "DELETE",
    });
}
const documentAttachmentsPath = "document-attachments";
//Create a new attachment for the given document.
export async function createDocumentAttachment(documentId, createDocumentAttachment) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentAttachmentsPath, {
        method: "POST",
        body: JSON.stringify(createDocumentAttachment)
    });
}
//Update an existing attachment
export async function patchDocumentAttachment(documentAttachmentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentAttachmentsPath + "/" + documentAttachmentId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing attachment
export async function deleteDocumentAttachment(documentAttachmentId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentAttachmentsPath + "/" + documentAttachmentId, {
        method: "DELETE"
    });
}
const finalizeDocumentPath = "finalize";
//Finalize an existing document
export async function finalizeDocument(documentId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + finalizeDocumentPath;
    return makeRequestWithSilentLogin(url, {
        method: "PATCH"
    });
}
const documentInformationPath = "document-information";
//Patch an existing document information
export async function patchDocumentInformation(documentInformationId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentInformationPath + "/" + documentInformationId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const cancelDocumentInformationPath = "cancel";
//Cancel an existing document information
export async function cancelDocumentInformation(documentInformationId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentInformationPath + "/" + documentInformationId + "/" + cancelDocumentInformationPath, {
        method: "PATCH",
    });
}
const massPatchDocumentInformationPath = "mass-patch";
//Adjust multiple document information at once.
export async function massPatchDocumentInformation(requests) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentInformationPath + "/" + massPatchDocumentInformationPath, {
        method: "PATCH",
        body: JSON.stringify(requests)
    });
}
const updateTotalPath = "total";
//Patch the total of an existing document
export async function patchDocumentTotal(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + updateTotalPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const documentTypeChangePath = "type-change";
//Change the document type of a document
export async function changeDocumentType(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentTypeChangePath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const documentTagsPath = "tags";
//Load a list of tags suggestion
export async function searchTagsForString(searchString) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentTagsPath + createQueryParameterFromString("search", searchString));
}
const documentByQrRefPath = "qr-ref";
//Load documents with a list of qr-refs
export async function getDocumentsByQrRef(qrRefLookup) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentByQrRefPath, {
        method: "POST",
        body: JSON.stringify(qrRefLookup)
    });
}
const recentlyUsedPath = "recently-used";
//Load a list of documents recently used
export async function getRecentlyUsedDocuments() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + recentlyUsedPath);
}
const massPatchDocumentPath = "mass-patch";
//Adjust multiple documents at once.
export async function massPatchDocument(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + massPatchDocumentPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const documentPartnerPath = "partners";
/**
 * Load the list of documents for a given partner.
 * @param filterParamters The filter to apply.
 * @returns list of documents to display
 */
export async function getPartnerDocuments(filterParamters) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filterParamters);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentPartnerPath;
    return makeRequestWithSilentLogin(url + query);
}
const documentMoneyPath = "money";
/**
 * Load the list of documents for the money list view.
 * @param filterParamters The filter to apply.
 * @returns list of documents to display
 */
export async function getMoneyDocuments(filterParamters) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filterParamters);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentMoneyPath;
    return makeRequestWithSilentLogin(url + query);
}
const exportMoneyDocumentsPath = "export";
/**
 * Request to export the money documents with the given filter
 * @param filterParamters The filter to apply.
 * @returns list of documents to display
 */
export async function requestMoneyDocumentsExport(filterParamters) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filterParamters);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentMoneyPath + "/" + exportMoneyDocumentsPath;
    return makeRequestWithSilentLogin(url + query, {
        method: "POST"
    });
}
const documentMoneyTotalPath = "money-total";
export async function getMoneyTotalForDocuments(filterParamters) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filterParamters);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentMoneyTotalPath;
    return makeRequestWithSilentLogin(url + query);
}
const situationDocumentCreationPath = "situation";
/**
 * Create a copy of the document but uses the given SituationDocumentCreation object as filter for the positions.
 * @param documentId
 * @param request
 * @returns The new created document id
 */
export async function createSituationDocuments(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + situationDocumentCreationPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const documentAddressesPath = "addresses";
//Create a new document address
export async function createDocumentAddress(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentAddressesPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing document address
export async function patchDocumentAddress(documentAddressId, patchRequest) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentAddressesPath + "/" + documentAddressId, {
        method: "PATCH",
        body: JSON.stringify(patchRequest)
    });
}
const changePlacmentOfDocumentAddressPath = "swap";
//Swap the position of two document addresses
export async function changePlacementOfDocumentAddresses(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentAddressesPath + "/" + changePlacmentOfDocumentAddressPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing document address
export async function deleteDocumentAddress(documentAddressId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentAddressesPath + "/" + documentAddressId, {
        method: "DELETE",
    });
}
const documentFactorGroupPath = "calculation-factor-groups";
//Update an existing document calculation factor
export async function patchDocumentCalculationFactor(calculationFactorGroupId, patchRequest) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentFactorGroupPath + "/" + calculationFactorGroupId, {
        method: "PATCH",
        body: JSON.stringify(patchRequest)
    });
}
const documentHeartBeatPath = "heart-beat";
//Apply the heart beat to the document.
export async function patchDocumentHeartBeat(documentId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentHeartBeatPath, {
        method: "PATCH",
    });
}
const documentPaymentPeriodValuePath = "document-payment-period-values";
//Create a document payment period value
export async function createDocumentPaymentPeriodValue(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentPaymentPeriodValuePath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing value
export async function patchDocumentPaymentPeriodValue(documentPaymentPeriodValueId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPaymentPeriodValuePath + "/" + documentPaymentPeriodValueId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing document payment period value
export async function deleteDocumentPaymentPeriodValue(documentPaymentPeriodValueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPaymentPeriodValuePath + "/" + documentPaymentPeriodValueId, {
        method: "DELETE",
    });
}
const addSettingPaymentPeriodValuesPath = "add-setting";
//Create a document payment period value
export async function addSettingPaymentPeriodToDocument(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentPaymentPeriodValuePath + "/" + addSettingPaymentPeriodValuesPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const replacePaymentPeriodValuesWithSettingPath = "replace-with-setting";
//Create a document payment period value
export async function replacePaymentPeriodValuesWithSetting(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentPaymentPeriodValuePath + "/" + replacePaymentPeriodValuesWithSettingPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
export const rapportPath = "rapports";
//Get a single document rapport
export async function getDocumentRapport(documentRapportId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + documentRapportId);
}
//Create a new document rapport
export async function createDocumentRapport(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + rapportPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Patch an existing document rapport
export async function patchDocumentRapport(documentRapportId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + documentRapportId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete a document rapport and everything connected to it.
export async function deleteDocumentRapport(documentRapportId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + documentRapportId, {
        method: "DELETE",
    });
}
//Copy an existing document rapport
export async function copyDocumentRapport(documentRapportId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + documentRapportId + "/" + copyPath, {
        method: "POST",
    });
}
const positionMassUpdate = "massupdate";
//Make a mass updat on a rapport
export async function patchDocumentRapportPositions(rapportId, patchRequest) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + rapportId + "/" + positionMassUpdate, {
        method: "PATCH",
        body: JSON.stringify(patchRequest)
    });
}
const copyDocumentPositionPath = "copy-positions";
//Create a copy of the given document position
export async function copyDocumentPosition(rapportId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + rapportId + "/" + copyDocumentPositionPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
export const documentPositionPath = "positions";
//Create a new document position
export async function createDocumentPosition(rapportId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + rapportId + "/" + documentPositionPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Delete existing document positions
export async function deleteDocumentPositions(positionIds) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const params = "?position-ids=" + positionIds.join(";");
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + params, {
        method: "DELETE",
    });
}
//Update an existing document position
export async function patchDocumentPosition(positionId, patchRequest) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId, {
        method: "PATCH",
        body: JSON.stringify(patchRequest)
    });
}
const analyzePath = "analyze";
//Analyze an existing document position
export async function analyzeDocumentPositions(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + analyzePath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
export const addFromCatalogueToPosition = "add-from-catalogue";
//Add a position from the catalogue
export async function addCataloguePositionToDocument(rapportId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + rapportId + "/" + addFromCatalogueToPosition, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const imagePath = "image";
export async function deleteImage(rapportId, positionId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + imagePath, {
        method: "DELETE",
    });
}
const resetPositionsPath = "reset";
//Reset the amount and delete all cost elements for the given rapport
export async function resetDocumentPosition(rapportId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + rapportId + "/" + resetPositionsPath, {
        method: "PATCH",
    });
}
const priceFactorPath = "price-factor";
//Reset the amount and delete all cost elements for the given rapport
export async function factorizeDocumentPositionPrice(rapportId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + rapportId + "/" + priceFactorPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const catalogueUpdatePath = "catalogue";
//Update all positions with the given catalogue.
export async function updateRapportByCatalogue(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + rapportPath + "/" + positionMassUpdate + "/" + catalogueUpdatePath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const typeChangePath = "change-type";
export async function changeDocumentPositionType(positionId, changeDocumentPositionType) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + typeChangePath, {
        method: "POST",
        body: JSON.stringify(changeDocumentPositionType)
    });
}
const reorderDocumentPositionPath = "reorder";
export async function reorderDocumentPosition(positionId, reorderDocumentPosition) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + reorderDocumentPositionPath, {
        method: "POST",
        body: JSON.stringify(reorderDocumentPosition)
    });
}
const addPositionToCataloguePath = "add-to-catalogue";
export async function addPositionToCatalogue(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + addPositionToCataloguePath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const documentConditionPath = "conditions";
//Create a new document condition
export async function createDocumentCondition(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentConditionPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing document condition
export async function patchDocumentCondition(documentConditionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentConditionPath + "/" + documentConditionId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
const documentConditionMassPath = "mass-update";
//Update existing document condition with a mass update
export async function massPatchDocumentCondition(documentId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPath + "/" + documentId + "/" + documentConditionMassPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing document condition
export async function deleteDocumentCondition(documentConditionId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentConditionPath + "/" + documentConditionId, {
        method: "DELETE",
    });
}
const documentCostElementPath = "document-cost-elements";
export async function createDocumentPositionCostElement(positionId, createDocumentPositionCostElement) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + documentCostElementPath, {
        method: "POST",
        body: JSON.stringify(createDocumentPositionCostElement)
    });
}
export async function patchDocumentPositionCostElement(costElementId, patchRequest) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentCostElementPath + "/" + costElementId, {
        method: "PATCH",
        body: JSON.stringify(patchRequest)
    });
}
const documentCostElementMultiPath = "cost-elements-multi";
//Create multiple cost elements at once.
export async function createMultipleDocumentPositionCostElements(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + documentCostElementMultiPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Removes an existing document position cost element
export async function deleteDocumentPositionCostElement(costElementId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentCostElementPath + "/" + costElementId, {
        method: "DELETE",
    });
}
const extentElementPath = "extents";
const extentMultiElementPath = "extents-multi";
//Create a new position extent on a existing position
export async function createDocumentPositionExtent(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + extentElementPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Create multiple document extent at once.
export async function createMultipleDocumentPositionExtent(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + documentPositionPath + "/" + positionId + "/" + extentMultiElementPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing extent
export async function patchDocumentPositionExtent(extentId, patchRequest) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + extentElementPath + "/" + extentId, {
        method: "PATCH",
        body: JSON.stringify(patchRequest)
    });
}
//Delete an existing document position extent
export async function deleteDocumentPositionExtent(extentId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + extentElementPath + "/" + extentId, {
        method: "DELETE",
    });
}
const textBlocksPath = "text-blocks";
//Load a list of text blocks
export async function getTextBlocks(textBlockFilter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(textBlockFilter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + textBlocksPath;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new text block
export async function createTextBlock(createTextBlock) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + textBlocksPath, {
        method: "POST",
        body: JSON.stringify(createTextBlock)
    });
}
//Delete an existing text block
export async function deleteTextBlock(textBlockId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + textBlocksPath + "/" + textBlockId, {
        method: "DELETE",
    });
}
//Update an existing text block
export async function patchTextBlock(textBlockId, patchTextBlock) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + textBlocksPath + "/" + textBlockId, {
        method: "PATCH",
        body: JSON.stringify(patchTextBlock)
    });
}
const partnerAddressPath = "partners-addresses";
//Create a new partner and a new single address
export async function createPartnerAddress(createPartner) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath, {
        method: "POST",
        body: JSON.stringify(createPartner)
    });
}
//Update an existing partner address
export async function patchPartnerAddress(partnerAddressId, patchPartnerAddress) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + partnerAddressId, {
        method: "PATCH",
        body: JSON.stringify(patchPartnerAddress)
    });
}
//Delete an existing partner address
export async function deletePartnerAddress(partnerAddressId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + partnerAddressId, {
        method: "DELETE",
    });
}
//Delete multiple partner addresses
export async function deletePartnerAddresses(partnerAddressIds) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = "?partners-address-ids=" + partnerAddressIds.join(";");
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath;
    return makeRequestWithSilentLogin(url + query, {
        method: "DELETE",
    });
}
const confirmPartnerUploadPath = "confirm";
//Confirm the file upload to the api
export async function confirmPartnerUpload(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + confirmPartnerUploadPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const partnerRelationTagsPath = "relation-tags";
//Load a list of tags suggestion for the partner tags
export async function searchPartnerRelationTagsForString(searchString) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + partnerRelationTagsPath + createQueryParameterFromString("search", searchString));
}
//Get a specific partners address
export async function getPartnerAddress(partnerAddressId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + partnerAddressId);
}
//Get a list of partners addresses
export async function getPartnerAddresses(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    //Create the url representation
    let query = createQueryFromFilter(filter);
    let url = base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath;
    return makeRequestWithSilentLogin(url + query);
}
const partnerAddressDataExportPath = "export";
//Request a data export for the partners
export async function requestPartnerAddressesExport(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    //Create the url representation
    let query = createQueryFromFilter(filter);
    let url = base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + partnerAddressDataExportPath;
    return makeRequestWithSilentLogin(url + query);
}
const massPatchPartnerAddressPath = "mass-patch";
//mass patch partner addresses
export async function massPatchPartnerAddress(partnerAddressesIds, massPatchPartnerAddresses) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = "?partners-address-ids=" + partnerAddressesIds.join(";");
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + partnerAddressPath + "/" + massPatchPartnerAddressPath;
    return makeRequestWithSilentLogin(url + query, {
        method: "PATCH",
        body: JSON.stringify(massPatchPartnerAddresses)
    });
}
const positionCataloguesPath = "catalogues";
//Get the available position catalogues
export async function getPositionCatalogues(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    let query = createQueryFromFilter(filter);
    let url = base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath;
    return makeRequestWithSilentLogin(url + query);
}
//Get the information about a specific position catalogue
export async function getPositionCatalogue(positionCatalogueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + positionCatalogueId);
}
//Create a new position catalogue
export async function createPositionCatalogue(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing position catalogue
export async function patchPositionCatalogue(positionCatalogueId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + positionCatalogueId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an exisiting position catalog.
export async function deletePositionCatalogue(positionCatalogueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + positionCatalogueId, {
        method: "DELETE",
    });
}
const exportPositionCataloguePath = "export";
//request the given position catalogue to be exported
export async function requestPositionCatalogueExport(positionCatalogueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + positionCatalogueId + "/" + exportPositionCataloguePath);
}
const confirmCatalogueFileUploadPath = "confirm";
//Confirm the file upload to the api
export async function confirmPositionCatalogueUpload(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + confirmCatalogueFileUploadPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const cataloguePositionPath = "catalogue-positions";
//Get the available position catalogues
export async function getPositionCataloguesPositions(catalogueIds, positionFilter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    //Build the catalogu id list
    let catIdsParam = "&catalogue-ids=" + catalogueIds.join(";");
    //Create the url representation
    let query = createQueryFromFilter(positionFilter) + catIdsParam;
    let url = base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + cataloguePositionPath;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new position
export async function createPositionCataloguesPosition(catalogueId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + positionCataloguesPath + "/" + catalogueId + "/" + cataloguePositionPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//get the detailed version of an existing position
export async function getPositionCataloguesPosition(positionId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionPath + "/" + positionId);
}
//patch an existing position
export async function patchPositionCataloguesPosition(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionPath + "/" + positionId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Copy an existing catalogue position
export async function copyPositionCataloguesPosition(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionPath + "/" + positionId + "/" + copyPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Remove an existing position
export async function deletePositionCataloguesPosition(positionId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionPath + "/" + positionId, {
        method: "DELETE",
    });
}
const cataloguePositionVariantPath = "variants";
//Create a new position variant
export async function createPositionCataloguesPositionVariant(positionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionPath + "/" + positionId + "/" + cataloguePositionVariantPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an exisiting variant
export async function patchPositionCataloguesPositionVariant(variantId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantPath + "/" + variantId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing variant
export async function deletePositionCataloguesPositionVariant(variantId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantPath + "/" + variantId, {
        method: "DELETE",
    });
}
const copyCostVariantCostElementsPath = "copy-cost-elements";
//Copy a set of cost elements to the target variant
export async function copyPositionCataloguesPositionVariantCostElements(variantId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantPath + "/" + variantId + "/" + copyCostVariantCostElementsPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const clearCostElementsPath = "clear";
//Clear all variant cost element
export async function clearPositionCataloguesPositionVariant(variantId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantPath + "/" + variantId + "/" + clearCostElementsPath, {
        method: "DELETE",
    });
}
const cataloguePositionVariantCostElementPath = "catalogue-cost-elements";
//Create a new cost element for a position element
export async function createPositionCataloguePositionCostElement(positionVaraintId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantPath + "/" + positionVaraintId + "/" + cataloguePositionVariantCostElementPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing cost element on the variant
export async function patchPositionCataloguePositionCostElement(costElementId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantCostElementPath + "/" + costElementId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Remove an existing cost element
export async function deletePositionCataloguePositionCostElement(costElementId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + cataloguePositionVariantCostElementPath + "/" + costElementId, {
        method: "DELETE",
    });
}
const costElementCataloguesPath = "cost-element-catalogue";
//Get a single cost element catalogue
export async function getCostElementCatalogue(costElementCatalogueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + costElementCatalogueId);
}
//Get the available cost element catalogues
export async function getCostElementCatalogues(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    let query = createQueryFromFilter(filter);
    let url = base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath;
    return makeRequestWithSilentLogin(url + query);
}
//Update an existing cost element catalogue
export async function patchCostElementCatalogue(costElementCatalogueId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + costElementCatalogueId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Confirm the file upload to the api
export async function confirmCostElementCatalogueUpload(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + confirmCatalogueFileUploadPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Create a new cost element catalogues
export async function createCostElementCatalogue(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Delete an exisiting cost element catalog.
export async function deleteCostElementCatalogue(costElementCatalogueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + costElementCatalogueId, {
        method: "DELETE",
    });
}
const exportCostElementCataloguePath = "export";
//Request an export of the cost element catalogue
export async function requestCostElementCatalogueExport(costElementCatalogueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + costElementCatalogueId + "/" + exportCostElementCataloguePath, {
        method: "POST"
    });
}
//Get a list of cost element positions
export async function getCostElementPositions(catalogueIds, filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    //Build the catalogue id list
    let catIdsParam = "&catalogue-ids=" + catalogueIds.join(";");
    let query = createQueryFromFilter(filter) + catIdsParam;
    let url = base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + cataloguePositionPath;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new cost element position
export async function createCostElementPosition(costElementCatalogueId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + costElementCatalogueId + "/" + cataloguePositionPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Patch an existing cost element position
export async function patchCostElementPosition(costElementId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + cataloguePositionPath + "/" + costElementId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
// copy an existing position
export async function copyCostElementPosition(costElementId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + cataloguePositionPath + "/" + costElementId + "/" + copyPath, {
        method: "POST",
    });
}
//Delete an existing cost element position
export async function deleteCostElementPosition(costElementId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + costElementCataloguesPath + "/" + cataloguePositionPath + "/" + costElementId, {
        method: "DELETE"
    });
}
const sbvPath = "sbv";
const sbvVersionPath = "versions";
export async function getSBVVersions() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + sbvPath + "/" + sbvVersionPath);
}
const sbvReionPath = "regions";
export async function getSBVRegions(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + sbvPath + "/" + sbvReionPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const sbvGetCatalogue = "catalog-load";
//Get the given catalogue
export async function getSBVCatalogue(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + sbvPath + "/" + sbvGetCatalogue, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
const userLicencesPath = "user-licences";
//Get a list of SBV user licences
export async function getSBVUserLicences(firmId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + sbvPath + "/" + firmPath + "/" + firmId + "/" + userLicencesPath);
}
const systemInformationPath = "system-information";
//Get the system information
export async function getSystemInformation() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + systemInformationPath);
}
//Patch the existing system information
export async function patchSystemInformation(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + systemInformationPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
